'use client'

import { useTranslation } from "react-i18next";
import { Facebook, Linkedin, Instagram, Send, Youtube } from 'lucide-react';
import { useFooterDisclaimer } from '@/core/hooks/useFooterDisclaimer';

const XLogo = ({ size = 20 }: { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
  </svg>
);

const socialLinks = [
  {
    icon: Facebook,
    link: 'https://www.facebook.com/LordToken.off',
  },
  {
    icon: Linkedin,
    link: 'https://www.linkedin.com/company/davensifr/',
  },
  {
    icon: XLogo,
    link: 'https://x.com/Davensi_off',
  },
  {
    icon: Instagram,
    link: 'https://www.instagram.com/lordtoken_off/',
  },
  {
    icon: Send,
    link: 'https://t.me/LordTokenGroupe',
  },
  {
    icon: Youtube,
    link: 'https://www.youtube.com/@Davensi',
  },
]

export default function Footer() {
  const { t } = useTranslation();
  const { content } = useFooterDisclaimer();

  return (
    <div className="footer">
      <span className="footer__content">
        {content}
      </span>
      <div className="footer-copyright">
        <span>{t('footer.copyright')}</span>
        <div className="footer-social-links">
          {
            socialLinks.map(({ icon: Icon, link }) => (
              <a href={link} key={link} target="_blank" rel="noopener noreferrer" className="social-link">
                <Icon size={20} />
              </a>
            ))
          }
        </div>
      </div>
    </div>
  )
}